import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AlertComponent } from '../../common/alert/alert.component';
import { PlatformComponent } from '../../models/workflow/Model.model';
import { flowsheet } from '../../models/workflow/flosheetList.model';
import { WorkflowService } from '../../services/workflow-service';
import { GlobalService } from '../../services/global.service';

@Component({
  selector: 'app-scenario-specification',
  templateUrl: './flowsheet-specification.component.html',
  styleUrls: ['./flowsheet-specification.component.css']
})
export class FlowsheetSpecificationComponent implements OnInit {
  componentDetails: PlatformComponent = new PlatformComponent();
  isLoading= false;
  readOnly: false;
  flowsheetSelected;
  modelErrorMessage;
  flowsheetsListDetails;
  selectedFlowsheet: flowsheet = new flowsheet();

  constructor(public dialogRef: MatDialogRef<FlowsheetSpecificationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public flowsheetService: WorkflowService,
    public dialog: MatDialog,
    public globals: GlobalService
    ) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.getFlowsheetList();
    this.componentDetails = this.data.component;
    this.readOnly = this.data.readOnly;
  }

  getFlowsheetList() {
    this.flowsheetService.getFlowSheetsList().subscribe((data: any): void => {
      if (data.length > 0) {
        let flowsheetfound: any;
        this.flowsheetsListDetails = data;
        flowsheetfound = this.flowsheetsListDetails.filter(f => f.flowSheetId == this.componentDetails.componentDetails.id);
        this.selectedFlowsheet = flowsheetfound.length > 0 ? flowsheetfound[0] : this.selectedFlowsheet;
      } else {
        this.globals.showAlert(AlertComponent, { success: false, message: "No Flowsheet availalble!" });
      }
      this.isLoading = false;
    }, (error: Error) => {
      this.globals.showAlert(AlertComponent, { success: false, message: "Error in fetching flowsheet list!" });
      this.isLoading = false;
    });
  }

  onSelectParameter(parameter) {
    this.flowsheetSelected = parameter;
  }

  saveFlowsheetDetails() {
    this.data.component.componentDetails.name = this.selectedFlowsheet.flowSheetName;
    this.data.component.componentDetails.id = this.selectedFlowsheet.flowSheetId;
    this.dialogRef.close(false);
  }

  onCancelClick() {
    this.dialogRef.close(false);
  }

}
